import type {
  CreateObjectAddressStepResponse,
  SaveCreateObjectAddressRequest,
} from 'shared/api/kyrgyzstan/create-object'

export interface CreateObjectAddressDraft {
  regionId: string
  cityId: number
  street: string
  houseNumber: string
  latitude: number | null
  longitude: number | null
}

export const mapCreateObjectAddressResponseToDraft = (
  address: CreateObjectAddressStepResponse,
): CreateObjectAddressDraft | null => {
  const regionId = address.region_id
  const cityId = address.city_id
  const street = address.street
  const houseNumber = address.house_number

  if (!regionId || cityId === null || !street || !houseNumber) {
    return null
  }

  return {
    regionId,
    cityId,
    street,
    houseNumber,
    latitude: address.geo?.lat ?? null,
    longitude: address.geo?.lng ?? null,
  }
}

export const mapCreateObjectAddressDraftToRequest = (
  addressDraft: CreateObjectAddressDraft,
): SaveCreateObjectAddressRequest => ({
  region_id: addressDraft.regionId,
  city_id: addressDraft.cityId,
  street: addressDraft.street.trim(),
  house_number: addressDraft.houseNumber.trim(),
  geo: {
    lat: addressDraft.latitude,
    lng: addressDraft.longitude,
  },
})
